import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import './App.css';
import './component/adminDashboard.css';
import WaitlistDashboard from './component/WaitlistDashboard';
import AccountDetails from './component/AccountDetails';
import Login from './component/Login'; 
import Profile from './component/profile'; 
import Navbar from './component/navbar';
import BrandAmbassadorDashboard from './component/BrandAmbassadorDashboard';
import PrivacyPolicy from './component/PrivacyPolicy';
import { auth } from './firebase';

const NotFound = () => (
  <div style={{ marginTop: '150px', textAlign: 'center' }}>
    <h1>404 - Page Not Found</h1>
    <p>The page you are looking for does not exist.</p>
  </div>
);

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((currentUser) => {
      setUser(currentUser); // Update user state when authentication changes
      setLoading(false);    // Stop loading indicator
    });
    return () => unsubscribe(); // Cleanup subscription
  }, []);

  if (loading) {
    return <div>Loading...</div>; // Show loading state until user auth is checked
  }

  return (
    <Router>
      <div className="root admin-shell">
        {user && <Navbar />} {/* Render Navbar only when the user is logged in */}
        <Routes>
          {/* Redirect '/' to '/profile' when user is logged in */}
          <Route
            path="/"
            element={<Navigate to={user ? "/profile" : "/login"} />}
          />
          <Route
            path="/waitlist-dashboard"
            element={user ? <WaitlistDashboard /> : <Navigate to="/login" />}
          />
          <Route
            path="/AccountDetails/:accountId"
            element={user ? <AccountDetails /> : <Navigate to="/login" />}
          />
          <Route
            path="/profile"
            element={user ? <Profile /> : <Navigate to="/login" />}
          />
          <Route
            path="/login"
            element={user ? <Navigate to="/profile" /> : <Login />}
          />
          <Route
            path="/brand-ambassador-dashboard"
            element={user ? <BrandAmbassadorDashboard /> : <Navigate to="/login" />}
          />
          {/* Public, unauthenticated - required for App Store Connect / Play Console's
              privacy policy URL field. No user ? guard, unlike every other route above. */}
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route
            path="*"
            element={user ? <NotFound /> : <Navigate to="/login" />}
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
